import Slider from 'react-slick'
import 'animate.css/animate.min.css'
import { useState } from 'react'

const SliderImages = ({ data }) => {
  const [sectionIndex, setSectionIndex] = useState('')
  const [Images, setImages] = useState('')
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4, // Default for larger screens
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024, // Medium devices (like tablets)
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768, // Small devices (like mobile in landscape)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480, // Extra small devices (like mobile in portrait)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  }

  const sortedData = data.sort((b, a) => b.displayOrder - a.displayOrder)
  return (
    <div>
      <div className='sliderImages' style={{ marginTop: '30px' }}>
        <Slider {...settings}>
          {sortedData.map((item, index) => (
            <div key={index} className='slide'>
              <img
                onClick={index => {
                  setSectionIndex(index)
                  setImages(item.ImagesPath)
                }}
                style={{
                  overflowClipMargin: 'unset',
                  objectPosition: 'center',
                  objectFit: 'cover',
                  width: '100%'
                }}
                src={item.ImagesPath}
                alt={item.title}
              />
            </div>
          ))}
        </Slider>
        {sectionIndex && (
          <div
            className='slider-fixed-images'
            onClick={() => setSectionIndex(!sectionIndex)}
          >
            <img
              style={{
                overflowClipMargin: 'unset',
                objectPosition: 'center',
                objectFit: 'cover',
                width: '40%'
              }}
              src={Images}
            />
          </div>
        )}
      </div>
    </div>
  )
}
export default SliderImages
